import { useState, useEffect } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { request } from "@/Api";
import { formattedCurrency } from "@/utils";

export default function PaymentHistory() {
    const [loading, setLoading] = useState(true);
    const [payments, setPayments] = useState([]);

    useEffect(() => {
        request
            .get("/payments/history")
            .then((response) => {
                setPayments(response.data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return loading ? (
        <CircularProgress />
    ) : (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow sx={{ fontWeight: "bold" }}>
                        <TableCell>Date</TableCell>
                        <TableCell align="right">Amount</TableCell>
                        <TableCell align="right">Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {payments.map((payment) => (
                        <TableRow
                            key={payment.id}
                            sx={{
                                "&:last-child td, &:last-child th": {
                                    border: 0,
                                },
                            }}
                        >
                            <TableCell component="th" scope="row">
                                {payment.created_at}
                            </TableCell>
                            <TableCell align="right">
                                {formattedCurrency(
                                    Math.round(payment.amount_total / 100),
                                    payment.currency,
                                )}{" "}
                                {payment.currency.toUpperCase()}
                            </TableCell>
                            <TableCell align="right">
                                {payment.payment_status}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
